import { IBaseIconProps } from "./IBaseIconProps";

export const ValidIcon = ({ color = "#fff" }: IBaseIconProps) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      version="1.1"
      x="0px"
      y="0px"
      viewBox="0 0 100 110"
      fill={color}
    >
      <path d="M87.9,10.4c-0.8-0.6-1.9-0.5-2.5,0.3L48.7,57.2L30.4,40.6c-0.9-0.8-2.2-0.9-3.2-0.2c-1.2,0.8-1.5,2.4-0.7,3.6l18,27  c0.5,0.7,1.2,1.4,2,1.8c2.9,1.7,6.5,0.7,8.2-2.2l0.2-0.3l33.4-57.6C88.7,11.9,88.6,10.9,87.9,10.4z" />
      <path d="M76.5,77.2c0,3.5-2.8,6.3-6.3,6.3H24.2c-3.5,0-6.3-2.8-6.3-6.3V31.3c0-3.5,2.8-6.3,6.3-6.3h41.6l5.1-6.4c-0.2,0-0.5,0-0.7,0  H24.2c-7,0-12.8,5.7-12.8,12.8v45.9c0,7,5.7,12.8,12.8,12.8h45.9c7,0,12.8-5.7,12.8-12.8V34.8L76.5,46V77.2z" />
    </svg>
  );
};
